import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";
import { ellipsesOverflow } from "@/styles/helper";

const emphasis = (theme: Theme) => ({
  backgroundColor: theme.system.backgroundBase,
  borderRadius: "0.5rem",
  fontWeight: typography.weightSemiBold,
  "> p": {
    fontWeight: typography.weightSemiBold,
  },
});

export const category = (theme: Theme) =>
  css({
    padding: "0.5rem 1rem",
    margin: "0.5rem 0",
    display: "block",
    "&:hover": emphasis(theme),
  });

export const categoryTitle = css({
  ...ellipsesOverflow,
  textTransform: "capitalize",
});

export const activeCategory = (theme: Theme) => css(emphasis(theme));

export const subCategoryTitle = css({
  textTransform: "capitalize",
});

export const activeSubCategoryTitle = css({
  fontWeight: typography.weightSemiBold,
});

export const categoryWithSubsTitleLink = (theme: Theme) =>
  css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.5rem 1rem",
    margin: "0.5rem 0",
    cursor: "pointer",
    "&:hover": emphasis(theme),
  });

export const subCategoryList = css({
  overflow: "hidden",
  maxHeight: 0,
  transition: `max-height 500ms cubic-bezier(0.455, 0.03, 0.515, 0.955)`,
});

export const subCategoryListActive = css({
  maxHeight: "50rem",
  transitionDuration: "700ms",
});

export const depthPadding = (depth: number) =>
  css({
    paddingLeft: `${depth}rem`,
  });
